export default "prod"
